// extracted by mini-css-extract-plugin
export default {"range":"ControlMid_range__TrXGR","rangeVolume":"ControlMid_rangeVolume__mZ14A"};